var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1307_38868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5286 0.922969C7.78895 0.66262 8.21106 0.66262 8.4714 0.922969L11.1381 3.58964C11.3984 3.84999 11.3984 4.2721 11.1381 4.53244C10.8777 4.79279 10.4556 4.79279 10.1953 4.53244L8.66667 3.00385V10.061C8.66667 10.4292 8.36819 10.7277 8 10.7277C7.63181 10.7277 7.33333 10.4292 7.33333 10.061V3.00385L5.80474 4.53244C5.54439 4.79279 5.12228 4.79279 4.86193 4.53244C4.60158 4.2721 4.60158 3.84999 4.86193 3.58964L7.5286 0.922969Z",
    fill: "#EB6E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 7.39437C3.03486 7.39437 3.33333 7.69285 3.33333 8.06104V13.3944C3.33333 13.5712 3.40357 13.7408 3.5286 13.8658C3.65362 13.9908 3.82319 14.061 4 14.061H12C12.1768 14.061 12.3464 13.9908 12.4714 13.8658C12.5964 13.7408 12.6667 13.5712 12.6667 13.3944V8.06104C12.6667 7.69285 12.9651 7.39437 13.3333 7.39437C13.7015 7.39437 14 7.69285 14 8.06104V13.3944C14 13.9248 13.7893 14.4335 13.4142 14.8086C13.0391 15.1837 12.5304 15.3944 12 15.3944H4C3.46957 15.3944 2.96086 15.1837 2.58579 14.8086C2.21071 14.4335 2 13.9248 2 13.3944V8.06104C2 7.69285 2.29848 7.39437 2.66667 7.39437Z",
    fill: "#EB6E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1307_38868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0610352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b5dd71d060faec137a712067b9676d69.svg";
export { ForwardRef as ReactComponent };